import repository from '@/services/repository';

const resource = '/Tasks';

export default {
    get(userId: string, unassigned: boolean = false, projectId: string | null = null, includeClosed: boolean = false) {
        let qry = `?userId=${userId}&unassigned=${unassigned}&includeClosed=${includeClosed}`;
        if (projectId) {
            qry += `&projectId=${projectId}`;
        }
        return repository.get<ITaskListItem[]>(`${resource}` + qry);
    },
    getCountOfMyTasks() {
        return repository.get<number>(`${resource}/count`);
    },
    getSingle(id: string) {
        return repository.get(`${resource}/${id}`);
    },
    create(payload: any) {
        return repository.post(`${resource}`, payload);
    },
    update(payload: any) {
        return repository.put(`${resource}/${payload.id}`, payload);
    },
    delete(id: string) {
        return repository.delete(`${resource}/${id}`);
    },
};
